// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Sidebar from "./components/Sidebar";
import Home from "./pages/home";
// import About from "./pages/About";
// import Photos from "./pages/Photos";
// import MilkPourGame from "./components/MilkPourGame";
import "./App.css"
const App = () => {
  return (
    <Router>
      {/* <Sidebar /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/about" element={<About />} />
        <Route path="/photos" element={<Photos />} /> */}
       
      </Routes> 
    </Router>
  );
};

export default App;
